/* global debounce, theme */
if (!customElements.get('cart-po')) {
  class CartPo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.errorEl = this.querySelector('.cart-po__error');
      this.form = this.closest('form');
      this.checkoutBtn = this.form ? this.form.querySelector('[name="checkout"]') : null;
      this.minLength = parseInt(this.getAttribute('data-min-length'), 10) || 1;

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        // Let the request complete even if the page navigates (e.g. clicking Checkout)
        keepalive: true
      };

      this.init();
    }

    init() {
      this.debouncedSave = debounce(this.save.bind(this), 300);
      // Debounced save while typing for responsiveness...
      this.addEventListener('input', this.debouncedSave);
      // ...and an immediate save on blur (e.g. tabbing/clicking away to Checkout)
      this.addEventListener('change', this.save.bind(this));
      // Sync error state and checkout button on every keystroke
      this.addEventListener('input', this.syncState.bind(this));

      // Require a PO number before allowing checkout (blocks the cart form submit)
      if (this.form) {
        this.submitHandler = this.handleSubmit.bind(this);
        this.form.addEventListener('submit', this.submitHandler);
      }
    }

    disconnectedCallback() {
      if (this.form && this.submitHandler) {
        this.form.removeEventListener('submit', this.submitHandler);
      }
    }

    get value() {
      return this.input ? this.input.value.trim() : '';
    }

    get isValid() {
      return this.value.length >= this.minLength;
    }

    save() {
      const trimmedValue = this.input ? this.input.value.trim() : '';
      this.fetchRequestOpts.body = JSON.stringify({ attributes: { 'PO Number': trimmedValue } });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    handleSubmit(evt) {
      if (!this.isValid) {
        evt.preventDefault();
        this.showError();
      }
    }

    showError() {
      // Open the disclosure panel if the user has collapsed it, so the field and error are visible
      const details = this.closest('details');
      if (details) details.open = true;

      if (this.errorEl) this.errorEl.classList.remove('hidden');
      if (this.input) {
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus();
      }
    }

    syncState() {
      // Sync error message, red border, and checkout button together on every keystroke
      if (this.isValid) {
        if (this.errorEl) this.errorEl.classList.add('hidden');
        if (this.input) this.input.removeAttribute('aria-invalid');
      } else {
        if (this.errorEl) this.errorEl.classList.remove('hidden');
        if (this.input) this.input.setAttribute('aria-invalid', 'true');
      }
      if (this.checkoutBtn) this.checkoutBtn.disabled = !this.isValid;
    }
  }

  customElements.define('cart-po', CartPo);
}
